import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import bindAll from 'lodash.bindall';
import LibraryComponent from '../../../components/library/library-no-modal';
import styles from '../../lib/global.css';
import { setUser } from "../../reducers/teach";
import { me } from '../../api/user';
import { showLoading } from "../loading/loading";
import ModalManager from "../modal/modal-manager";
import renderVipModal from '../pay-modal/pay-modal';
import LoginRegModal from "../login-reg-modal/login-reg-modal";
import moment from 'moment';

class LessonList extends React.PureComponent {
    constructor(props) {
        super(props);
        bindAll(this, [
            'handleItemSelect'
        ]);
    }

    getUser() {
        me({}, { quiet: false }).then(res => {
            this.props.setUser(res)
        });
    }

    handleItemSelect(item) {
        const { user } = this.props
        if (!user.name) {
            ModalManager.open(LoginRegModal, {
                closeAfterSubmit: true,
                onClose: () => { },
                setUser, showLoading
            }, 'login');
            return
        }
        if (item.vip) {
            const inVip = this.props.user.vip ? this.props.user.vip > moment() ? false : true : false;
            if (!inVip) {
                if (window.__wxjs_environment === 'miniprogram') {
                    wx.miniProgram.redirectTo({ url: '/pages/pay/pay' });
                } else {
                    ModalManager.open(renderVipModal, {
                        user,
                        onClose: () => { },
                        onReload: () => this.getUser(),
                        setUser
                    })
                }
                return
            }
        }
        if (item.disableUrl) {
            this.props.history.push(item.disableUrl);
        } else {
            this.props.history.push({ pathname: "/lesson", search: item.extensionId });
        }
    }

    render() {
        const cornerStyle = [
            { backgroundColor: '#969696' }, //锁定中
            { backgroundColor: '#9494fa' }, //1.已解锁
            { backgroundColor: '#9494fa' }, //2.学习中
            { backgroundColor: '#9494fa' }, //3.待作业
            { backgroundColor: '#9494fa' }, //4.作业中
            { backgroundColor: '#52fa52' }, //5.完成
        ];
        const items = this.props.items.map((item, index) => {
            //没有Record或者时间没到，都处于锁定状态0
            let date = !!item.time && moment(item.time, "YYYY-MM-DD hh:mm");
            if (item.time === '') date = moment('1970-01-01 08:00', "YYYY-MM-DD hh:mm");
            const disabled = !(item.unlocked || (item.unlocked === undefined && date && date < moment()));
            const progress = (item.record ? item.record.progress : 0);
            const lessonVip = this.props.vip ? index + 1 > this.props.vip ? true : false : false;
            return {
                extensionId: 'id=' + item.id + (this.props.courseId ? '&course_id=' + this.props.courseId : '') + (this.props.clazzId ? '&clazz_id=' + this.props.clazzId : ''),
                name: item.name,
                rawURL: window.config.staticURL + '/cover/lesson/' + item.id + '.png',
                //iconRawURL: "/static/appstore.png",
                //insetIconURL: item.studying ? require('./studying.png') : undefined,
                featured: true,
                disabled: disabled && !this.props.disableUrl,
                disableUrl: this.props.disableUrl,
                cornerText: disabled ? window.L('teach.lesson.locked') : window.L('teach.lesson.progress_' + progress),
                cornerStyle: disabled ? cornerStyle[0] : cornerStyle[progress],
                vip: lessonVip,
                description: date ? (
                    <div className={styles.antRow}>
                        <div className={styles.antCol24}>
                            <div className={styles.antRow}>
                                <div className={styles.antCol24}>{item.time}</div>
                            </div>
                            <div className={styles.antRow}>
                                <div className={styles.antCol24}>{null}</div>
                            </div>
                        </div>
                    </div>
                ) : null,
            };
        });
        return (
            <React.Fragment>
                {/*<img style={{position: "absolute", zIndex:1, left:"18px", top:"21px"}} src={require('./new.png')} />*/}
                <LibraryComponent
                    data={items}
                    filterable={!!this.props.filterable}
                    id="LessonLibrary"
                    title="Lessons"
                    visible={true}
                    onItemSelected={this.handleItemSelect}
                    onRequestClose={this.props.onRequestClose}
                />
            </React.Fragment>
        );
    }
}

LessonList.propTypes = {
    items: PropTypes.arrayOf(PropTypes.object),
    courseId: PropTypes.number,
    clazzId: PropTypes.number,
    onRequestClose: PropTypes.func,
    disableUrl: PropTypes.string, //当item为disable的时候，如果有disableUrl，依然可以点击
}

const mapStateToProps = state => ({
    username: state.teach.user ? state.teach.user.name : null,
    user: state.teach.user
});

const mapDispatchToProps = dispatch => ({
    setUser: user => dispatch(setUser(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(LessonList));
